export default {
  NODE: {
    value: 'NODE',
    label: 'Node'
  },
  PEER_CONNECTION: {
    value: 'PEER_CONNECTION',
    label: 'Peer Connection'
  },
  VOIP_PEER: {
    value: 'VOIP_PEER',
    label: 'VoIP Peer'
  }
};
